import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { PersonasService } from "app/main/apps/shared/services/rest/personas.service";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-dialog-usuario",
    templateUrl: "./dialog-usuario.component.html",
    styleUrls: ["./dialog-usuario.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogUsuarioComponent implements OnInit, OnDestroy {
    formCliente: FormGroup;
    subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogUsuarioComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private _validadoresFormSrvc: ValidadoresFormularioService,
        private _personasSrvc: PersonasService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.initForm();
        //console.log(this.data);
    }

    initForm() {
        this.formCliente = this.fb.group({
            correo: [
                this.data?.usuario?.email || null,
                { validators: [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")] },
            ],
            nombres: [
                this.data?.usuario?.nombres || null,
                { validators: [Validators.required, Validators.minLength(3), Validators.maxLength(100)] },
            ],
            apellidos: [
                this.data?.usuario?.apellidos || null,
                { validators: [Validators.required,Validators.minLength(3), Validators.maxLength(100)] },
            ],
            rut: [
                this.data?.usuario?.rut || null,
                {
                    validators: [
                        Validators.required,
                        this._validadoresFormSrvc.validadorRut(),
                    ],
                },
            ],
            puedeCotizar: [
                this.data?.usuario?.permisos?.puedeCotizar || null,
                null,
            ],
            puedeComprar: [
                this.data?.usuario?.permisos?.puedeComprar || null,
                null,
            ],
            puedeRecibir: [
                this.data?.usuario?.permisos?.puedeRecibir || null,
                null,
            ],
        });
    }

    get nombres() {
        return this.formCliente.get("nombres");
    }
    get apellidos() {
        return this.formCliente.get("apellidos");
    }
    get rut() {
        return this.formCliente.get("rut");
    }

    get correo() {
        return this.formCliente.get("correo");
    }

    buscarEncargado() {
        try{
            let rut = this.formCliente.get("rut").value;
            if (rut.split("-").length == 2){
                let r = rut.split("-")[0];
                this.subscripciones.add(
                    this._personasSrvc.fetchPersona(r).subscribe((resp) => {
                        //console.log("resp");
                        //console.log(resp);
                        this.formCliente.get("correo").setValue(resp.email);
                        this.formCliente.get("nombres").setValue(resp.nombres);
                        this.formCliente.get("apellidos").setValue(resp.apellidos);
                    })
                );
            }
        }
        catch(e){
        }

        

    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
